import React, { useState, useEffect } from 'react'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import useClasses from '../common/useClasses'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

interface Props {
  dropDownData: { Name: string; Key: string }[]
  placeholderValue?: any
  selectedData: any
  onChange: (e: any) => void
}

const useStyles = ({
  option:{
    padding:0,
    fontSize:'12px'
  }
})

const MultipleDropdownSelect: React.FC<Props> = (props: Props) => {
const classes = useClasses(useStyles);
  const [selectedValue, setSelectedValue] = useState<
    { Name: string; Key: string }[]
  >([])

  useEffect(() => {
    if (selectedValue) {
      const val = selectedValue.map((res) => res.Key).join(';')
      props.onChange(val)
    }
  }, [selectedValue])

  useEffect(() => {
    if (props.selectedData !== null || props.selectedData !== undefined) {
      const defaultVal = props?.selectedData?.split(';')
      const modifiedValue: any = props.dropDownData
        .map((res) => {
          if (
            defaultVal?.some((response: any) => {
              if (response === res.Key) {
                return res
              }
            })
          ) {
            return res
          }
        })
        .filter(Boolean)
      setSelectedValue(modifiedValue)
    }
  }, [props?.selectedData])

  return (
    <Autocomplete
      classes={{option:classes.option}}
      multiple
      limitTags={2}
      //   id="checkboxes-tags-demo"
      id="multiple-limit-tags"
      options={props?.dropDownData}
      disableCloseOnSelect
      onChange={(e, Key) => {
        setSelectedValue(Key)
      }}
      value={selectedValue}
      getOptionLabel={(option) => option.Name}
      renderOption={(option:any, state:any) => {
        const selectedValueIndex = selectedValue.findIndex(
          (data) => data.Name.toLowerCase() === 'all',
        )
        if (selectedValueIndex > -1) {
          state.selected = true
        }
        return (
          <React.Fragment>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={state.selected}
            />
            {option.Name}
          </React.Fragment>
        )
      }}
      style={{ width: 371 }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          //   label="Checkboxes"
          placeholder={selectedValue.length > 0 ? null : props.placeholderValue}
        />
      )}
    />
  )
}

export default MultipleDropdownSelect
